import React from 'react';
import { Link } from 'react-router-dom';
import { Battery, ChevronLeft, Clock, Zap, Scale, Shield, ArrowRight } from 'lucide-react';

const ChargingStations: React.FC = () => {
  const features = [
    {
      icon: <Battery className="w-12 h-12 text-primary-500" />,
      title: "Recharge Rapide",
      description: "Rechargez votre moto en 2-3 heures seulement avec nos bornes de recharge rapide."
    },
    {
      icon: <Zap className="w-12 h-12 text-primary-500" />,
      title: "Énergie Verte",
      description: "Stations alimentées par énergie solaire pour une recharge 100% écologique."
    },
    {
      icon: <Clock className="w-12 h-12 text-primary-500" />,
      title: "24/7 Disponible",
      description: "Accès aux stations jour et nuit, avec assistance téléphonique permanente."
    },
    {
      icon: <Shield className="w-12 h-12 text-primary-500" />,
      title: "100% Sécurisé",
      description: "Paiement sécurisé et surveillance vidéo pour votre tranquillité."
    }
  ];

  const stats = [
    { value: "50+", label: "Stations" },
    { value: "10k+", label: "Recharges/mois" },
    { value: "99.9%", label: "Disponibilité" },
    { value: "24/7", label: "Support" }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-primary-50 to-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_10%_10%,_rgba(24,153,78,0.05)_0%,_transparent_50%)]"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-neutral-900 mb-4 sm:mb-5 md:mb-6 bg-gradient-to-r from-primary-600 to-primary-800 bg-clip-text text-transparent">
            Nos Stations de Recharge
          </h2>
          <p className="text-base sm:text-lg text-neutral-600 leading-relaxed px-4">
            Découvrez notre réseau de stations Proxy Power, conçues pour vous offrir une recharge rapide, fiable et écologique partout en Afrique.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center mb-10 sm:mb-12 md:mb-16">
          <div>
            <div className="grid grid-cols-2 gap-4 sm:gap-5 md:gap-6 mb-6 sm:mb-7 md:mb-8">
              {stats.map((stat, index) => (
                <div key={index} className="bg-white p-4 sm:p-5 md:p-6 rounded-xl shadow-lg border border-primary-100 hover:border-primary-200 transition-all duration-300 transform hover:translate-y-[-4px]">
                  <div className="text-2xl sm:text-3xl font-bold text-primary-500 mb-1 sm:mb-2">{stat.value}</div>
                  <div className="text-sm sm:text-base text-neutral-600">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="space-y-4 sm:space-y-5 md:space-y-6">
              <p className="text-base sm:text-lg text-neutral-600 leading-relaxed">
                Notre technologie de recharge rapide vous permet de recharger votre moto en un temps record, 
                tandis que notre application vous aide à localiser la station la plus proche et à suivre 
                votre consommation en temps réel.
              </p>
              <Link
                to="/stations"
                className="inline-flex items-center px-5 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base bg-primary-500 hover:bg-primary-600 text-white rounded-lg transition-colors shadow-lg hover:shadow-xl transform hover:translate-y-[-2px]"
              >
                Trouver une station
                <ArrowRight size={18} className="ml-2" />
              </Link>
            </div>
          </div>

          <div className="bg-primary-50 rounded-xl p-6 flex items-center justify-center group">
            <img 
              src="/StationSolar.png" 
              alt="Station Proxy Power" 
              className="max-w-full h-auto rounded-lg shadow-lg transform transition-all duration-700 group-hover:scale-105"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-lg border border-primary-100 hover:border-primary-200 transition-all hover:shadow-xl transform hover:translate-y-[-4px]">
              <div className="mb-4 p-3 bg-primary-50 rounded-xl inline-block">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-neutral-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-neutral-600">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChargingStations;